import { Link } from "react-router-dom";

export function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-white">
      <nav className="container-pn flex h-16 items-center justify-between md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center bg-navy font-heading text-lg font-black text-white">
            HH
          </span>
          <span className="font-heading text-base font-extrabold tracking-tight text-navy sm:text-lg">
            HAYS HOLDINGS <span className="text-foreground/40">INC</span>
          </span>
        </Link>

        <Link
          to="/contact"
          data-testid="nav-cta"
          className="bg-orange px-4 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-orange-dark sm:px-5 sm:text-sm"
        >
          Partner With Us
        </Link>
      </nav>
    </header>
  );
}
